/*
 Author : Raphaël Dardeau

 Markup :

 <nav class="navigation js-sticky">
 ...
 </nav>

 Setup :

 $(function() {
 $(".js-sticky").sticking();
 });
 */
;(function ($, window, document, undefined) { // eslint-disable-line
    "use strict";

    var pluginName = "sticking",
        defaults = {
            stickyClass: "is-sticky",
            parent: {
                element: "body",
                stickyClass: "",
                offset: 0
            },
            start: "top", // top or bottom
            length: false,
            offset: 0
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.setVars();
            this.setEvents();
        },
        setElements: function () {
            this.$element = $(this.element);
            if (this.settings.parent.element) {
                this.$parentElement = $(this.settings.parent.element);
            }
            this.$window = $(window);
            this.$document = $(document);
        },
        setVars: function () {
            this.isSticky = false;
            this.elementTop = this.$element.offset().top;
            this.elementHeight = this.$element.height();
            this.elementStart = (this.settings.start == "bottom") ? this.elementTop + this.elementHeight + this.settings.offset : this.elementTop + this.settings.offset;
            if (this.settings.length) {
                this.elementEnd = this.elementStart + this.settings.length;
            } else {
                this.elementEnd = this.$document.height() * this.$window.height();
            }
            if (this.$parentElement.length) {
                this.parentInitialMarginTop = this.$parentElement.css("marginTop");
            }

        },
        setEvents: function () {
            this.$window.on("scroll", $.proxy(function () {
                var scrollTop = this.$window.scrollTop();

                if (scrollTop >= this.elementStart && scrollTop <= this.elementEnd && !this.isSticky) {
                    this.isSticky = true;
                    this.$element.addClass(this.settings.stickyClass);
                    if (this.settings.parent.stickyClass) {
                        this.$parentElement.addClass(this.settings.parent.stickyClass);
                    }
                    if (this.settings.parent.offset) {
                        this.$parentElement.css("marginTop", this.settings.parent.offset + "px");
                    }
                } else if ((scrollTop < this.elementStart || scrollTop > this.elementEnd) && this.isSticky) {
                    this.isSticky = false;
                    this.$element.removeClass(this.settings.stickyClass);
                    if (this.settings.parent.stickyClass) {
                        this.$parentElement.removeClass(this.settings.parent.stickyClass);
                    }
                    if (this.settings.length && scrollTop > this.elementEnd) {
                        this.$parentElement.css("marginTop", this.settings.length);
                    } else if (this.settings.parent.offset) {
                        this.$parentElement.css("marginTop", this.parentInitialMarginTop);
                    }
                }
            }, this));
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
